<template>
  <router-view />
</template>

<script>
export default {
  name: 'CommonRouterView'
}
</script>

<style scoped>

</style>
